
import { get } from 'svelte/store'

import { apiPostJson } from '$lib/proxy/apiProxy'
import { DOC_TYPE } from '$lib/types/document'

import { account_templates_store } from '../account_templates/account_templates'
import { InitAccountTemplates, upsertAccTemplate } from '../account_templates/manager'
import { account_template_store as store } from './account_template'
import { makeAccTemplate } from './factories'
import type { AccTemplate } from './types'


export async function GetAccTemplateConfig(doc_type: DOC_TYPE, template_id: string) {

	await InitAccountTemplates()

	const acc_templates = get(account_templates_store)

	let acc_template = acc_templates.find(item => item.doc_type === doc_type && item.template_id === template_id)
	if(!acc_template){
		// first time config, not initialized yet
		acc_template = makeAccTemplate({doc_type, template_id})
	}
	console.log('GetAccTemplateConfig', acc_templates.length, acc_template)

	store.set(acc_template)

	return acc_template

}

export async function SetAccTemplateConfig (acc_template: AccTemplate) {

	console.log('SetAccTemplateConfig 1')
	// set acc_templates
	upsertAccTemplate(acc_template)
	// const acc_templates = get(account_templates_store)
	// const new_acc_templates = acc_templates.map((template) => {
	// 	if(template.id === acc_template.id)
	// 		return acc_template
	// 	else 
	// 		return template
	// })
	// console.log('SetAccTemplateConfig 2', new_acc_templates)
	// account_templates_store.set(new_acc_templates)

	// set acc_template
	console.log('SetAccTemplateConfig 3')
	store.set(acc_template)
	const url = `/account_templates/config/${acc_template.doc_type}/${acc_template.template_id}`
	await apiPostJson(url, { config: acc_template.user_config })
	console.log('SetAccTemplateConfig 4')
	// await InitAccountTemplates(fetch, true)

	return
}


